import { UntypedFormControl } from '@angular/forms';

export class Interchange {
  brandLabel: UntypedFormControl;
  brandId: UntypedFormControl;
  partNumber: UntypedFormControl;
  typeCode: UntypedFormControl;
  qualityGradeLevel: UntypedFormControl;
  languageCode: UntypedFormControl;
  interchangeNotes: UntypedFormControl;
  internalNotes: UntypedFormControl;
}
